import {
  AccountResult,
  baseStringMethods,
  ContactResult,
  ConvertMethod,
  NumberResult,
  ResultType,
  ResultTypesEnum,
  StringResult,
  TeammateResult,
} from './internal';

export const emailType: ResultType = {
  name: ResultTypesEnum.EMAIL,
  properties: {
    domain: StringResult,
    local_part: StringResult,
    length: NumberResult,
  },
  methods: {
    ...baseStringMethods,
    to_teammate: new ConvertMethod(TeammateResult),
    to_contact: new ConvertMethod(ContactResult),
    domain_to_account: new ConvertMethod(AccountResult),
  },
};
